module.exports = __webpack_public_path__ + "static/img/pic_dkjj_gjdkjcss.5d708569.png";